export default __webpack_public_path__ + "static/media/upcoming3.4e976f97.jpg";